import { API_BASE_URL } from '../../config';

export const handleRegister = async (formData: any) => {
    const url = `${API_BASE_URL}/referidos`;
    const token = localStorage.getItem('token');

    const data = {
        numero_cedula: formData.cedula,
        nombre_completo: formData.nombre_completo,
        alias: formData.alias || "",
        edad: formData.edad || "",
        genero: formData.genero || "",
        direccion_de_residencia: formData.direccion || "",
        municipio_id: formData.municipio_id || null,
        lugar_de_votacion: formData.lugarVotacion || "",
        mesa_de_votacion: formData.mesaVotacion || "",
        telefono: formData.telefono,
        // Relación jerárquica: quién lo presentó/invitó
        referido_id: formData.referido_id || null,
        // usuario_id lo asigna el backend desde el JWT — no se envía desde el cliente
    };

    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify(data)
    });

    const rawText = await response.text();

    let result: any;
    try {
        result = JSON.parse(rawText);
    } catch {
        console.error("El backend no devolvió JSON válido:", rawText);
        throw new Error("El servidor envió datos inválidos. Revisa la consola.");
    }

    if (!response.ok) {
        throw new Error(result?.message || "Error en el servidor");
    }

    return result;
};